import axios from "axios";
import interceptors from "@/shared/api/interceptors";
import i18n from "@/shared/config/i18n";

const apiClientNotifications = axios.create({
  baseURL: window.__CONFIG__.VUE_APP_BASE_DOMAIN + "/notification",
  withCredentials: true,
});

apiClientNotifications.interceptors.request.use((cfg) => {
  const locale =
    (i18n.global && (i18n.global.locale?.value || i18n.global.locale)) ||
    localStorage.getItem("lang") ||
    "ru";
  cfg.headers["Accept-Language"] = locale;
  return cfg;
});

interceptors(apiClientNotifications);

export default apiClientNotifications;
